export interface RandomSource {
  next(): number;
}

export const defaultRandomSource: RandomSource = {
  next: () => Math.random(),
};

/** Deterministic PRNG (mulberry32) for reproducible tests and replays. */
export function createSeededRandomSource(seed: number): RandomSource {
  let state = seed >>> 0;
  return {
    next() {
      state = (state + 0x6d2b79f5) >>> 0;
      let t = state;
      t = Math.imul(t ^ (t >>> 15), t | 1);
      t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    },
  };
}

export function randomIntInRange(random: RandomSource, minInclusive: number, maxInclusive: number): number {
  if (maxInclusive < minInclusive) throw new Error('maxInclusive must be >= minInclusive');
  const span = maxInclusive - minInclusive + 1;
  return minInclusive + Math.floor(random.next() * span);
}
